import * as React from "react";
import { useForm } from "react-hook-form";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
type ContactFormData = {
  name: string;
  email: string;
  message: string;
};
export default function ContactInformation() {
  const form = useForm<ContactFormData>({
    defaultValues: {
      name: "",
      email: "",
      message: ""
    }
  });
  const onSubmit = (data: ContactFormData) => {
    console.log("Form submitted:", data);
  };
  return <section className="bg-background py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground">
            Contact Information
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Get in touch with Aran Group for expert consulting services
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2">
          {}
          <Card className="border-border shadow-soft">
            <CardHeader>
              <CardTitle className="text-2xl font-semibold text-foreground">
                Send us a message
              </CardTitle>
            </CardHeader>
            <CardContent>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
                  <FormField control={form.control} name="name" rules={{
                  required: "Name is required"
                }} render={({
                  field
                }) => <FormItem>
                        <FormLabel>Name</FormLabel>
                        <FormControl>
                          <input type="text" placeholder="Your name" className="focus-ring w-full rounded-md border border-border bg-background px-4 py-2.5 text-foreground transition-all duration-[var(--duration-medium)] focus:border-primary" {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>} />

                  <FormField control={form.control} name="email" rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address"
                  }
                }} render={({
                  field
                }) => <FormItem>
                        <FormLabel>Email</FormLabel>
                        <FormControl>
                          <input type="email" placeholder="your.email@example.com" className="focus-ring w-full rounded-md border border-border bg-background px-4 py-2.5 text-foreground transition-all duration-[var(--duration-medium)] focus:border-primary" {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>} />

                  <FormField control={form.control} name="message" rules={{
                  required: "Message is required"
                }} render={({
                  field
                }) => <FormItem>
                        <FormLabel>Message</FormLabel>
                        <FormControl>
                          <textarea placeholder="Tell us about your project" rows={5} className="focus-ring w-full resize-none rounded-md border border-border bg-background px-4 py-2.5 text-foreground transition-all duration-[var(--duration-medium)] focus:border-primary" {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>} />

                  <Button type="submit" className="btn-primary w-full rounded-md px-6 py-3 font-semibold shadow-soft">
                    Send Message
                  </Button>
                </form>
              </Form>
            </CardContent>
          </Card>

          {}
          <div className="flex flex-col gap-6">
            <Card className="border-border shadow-soft">
              <CardHeader>
                <CardTitle className="text-2xl font-semibold text-foreground">
                  Contact Details
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                    <Mail className="size-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="mb-1 font-semibold text-foreground">
                      Email
                    </h3>
                    <Link to="mailto:alvaro@arangroup.net" className="text-muted-foreground transition-colors hover:text-primary">
                      alvaro@arangroup.net
                    </Link>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-secondary/10">
                    <Phone className="size-6 text-secondary" />
                  </div>
                  <div>
                    <h3 className="mb-1 font-semibold text-foreground">
                      Phone
                    </h3>
                    <Link to="tel:+13053425287" className="text-muted-foreground transition-colors hover:text-secondary">
                      (305) 342-5287
                    </Link>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-accent/10">
                    <MapPin className="size-6 text-accent" />
                  </div>
                  <div>
                    <h3 className="mb-1 font-semibold text-foreground">
                      Location
                    </h3>
                    <p className="text-muted-foreground">16660 Sw 85th Lane, Miami, FL 33193</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {}
            <Card className="border-border shadow-soft">
              <CardContent className="p-0">
                <div className="relative h-64 w-full overflow-hidden rounded-lg">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1399276/img/cityville_map_location.png" alt="Map showing Aran Group location" className="size-full object-cover" />
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}